import { MAX_HARVEST_RECORD_AMOUNT_GRAMS } from "@common/consts/harvestRecords";
import type { IWeightFormatter } from "@common/helpers/WeightFormatter";

export const maxHarvestAmount = (formatter: IWeightFormatter, unit: string) =>
  formatter.toSpecificUnit(MAX_HARVEST_RECORD_AMOUNT_GRAMS, unit);
